import { createStore } from 'vuex'
import user from '@/store/user'
import apiStorage from '@/store/apiStorage';
import cargos from '@/store/modules/cargos'
import ati from '@/store/modules/ati'
import executors from '@/store/modules/executors'
import newAti from '@/store/modules/newAti';
import trade from '@/store/modules/trade';
import dadata from '@/store/modules/dadata'
import applications from '@/store/modules/applications'
import distributionApprovals from '@/store/modules/distributionApprovals'
import pureBidding from '@/store/modules/pureBidding'
import tmsActionLog from '@/store/modules/tmsActionLog'
import tripsResync from '@/store/modules/tripsResync'



export default createStore({
  modules: {
    user,
    apiStorage,
    cargos,
    executors,
    ati,
    newAti,
    trade,
    dadata,
    applications,
    distributionApprovals,
    pureBidding,
    tmsActionLog,
    tripsResync
  }
})
